<template>
    <div>
        <b-row class="mb-1">
            <b-col :md="12">
                <PluginSelectAccount
                    v-model="project"
                    plugin="regularbilling"
                    class="select-bg-white"
                ></PluginSelectAccount>
            </b-col>
        </b-row>
        <RegisterCardContainer
            :project="project"
        ></RegisterCardContainer>
    </div>
</template>

<script>
import store from '@/store'
import PluginSelectAccount from '@/components/PluginSelectAccount.vue'
import RegisterCardContainer from '@/modules/RegisterCard'
import RegisterCardStore from '@/modules/RegisterCard/_store'
import { getCurrentInstance, ref, computed } from '@vue/composition-api'
import { REGULLAR_BILLING } from '@/service'
const STORE_KEY = '$_register_card'
export default {
    components: {
        PluginSelectAccount,
        RegisterCardContainer
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const project = ref({})
        const userRights = computed(() => store.getters.userRights)
        const pluginProjects = computed(() => userRights.value.find(item => item.serviceName === REGULLAR_BILLING).projects)
        const firstProject = pluginProjects.value[0]
        store.dispatch(`${STORE_KEY}/getRegularBillingAllatkey`, { usageAccountId: firstProject.usageAccountId }).then(() => {
            store.dispatch(`${STORE_KEY}/getRegularBillingHistory`, { projectIdx: firstProject.projectIdx, usageAccountId: firstProject.usageAccountId })
        })
        return {
            project
        }
    },
    beforeRouteEnter (to, from, next) {
        if (!(STORE_KEY in store._modules.root._children)) {
            store.registerModule(STORE_KEY, RegisterCardStore)
        }
        next()
    }
}
</script>

<style>

</style>
